import { RBCheck } from '@lfw/roesberg';

export class HelpSettings {
  public defaultHelpFileVisible = false;
  public customHelpFile = '';
  public customHelpFileText = '';

  public customHelpFileVisible(): boolean {
    return !RBCheck.isNullOrEmpty(this.customHelpFile) && !RBCheck.isNullOrEmpty(this.customHelpFileText);
  }
}
